var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinButton5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_826_14306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint0_radial_826_14306)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint1_radial_826_14306)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint2_radial_826_14306)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint3_radial_826_14306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2922 52.7305V55.2109H42.5344V60.9141H39.4289V55.2109H32.8078V52.7305H49.2922ZM34.6242 51.1094V43.6875H47.4367V51.1094H34.6242ZM37.6906 48.668H44.3117V46.1484H37.6906V48.668ZM65.3969 56.5391V59.0781H48.893V56.5391H52.8578V54.1953H50.6898V47.8086H60.5141V46.4414H50.6703V43.9414H63.6195V50.2695H53.8344V51.6758H64.0297V54.1953H61.6664V56.5391H65.3969ZM55.9047 56.5391H58.5805V54.1953H55.9047V56.5391ZM71.1305 59.1953C67.9176 59.1953 65.6031 57.3496 65.5836 54.7422H69.1969C69.2262 55.7285 70.0855 56.373 71.1305 56.3633C72.3414 56.373 73.191 55.5332 73.1812 54.2734C73.191 52.9941 72.3414 52.1543 71.1305 52.1641C70.1637 52.1543 69.5387 52.5645 69.1969 53.2773H65.8961L66.5016 44.8594H75.8961V47.8281H69.568L69.275 51.0117H69.3531C69.8121 50.1816 70.9547 49.5664 72.3609 49.5664C74.9 49.5664 76.7848 51.4707 76.775 54.1562C76.7848 57.1055 74.5387 59.1953 71.1305 59.1953ZM92.118 42.8672V60.9336H89.0125V42.8672H92.118ZM76.7859 55.6602C78.0555 55.6602 79.5008 55.6602 81.0242 55.6309V54.3613C79.1785 53.9414 77.9773 52.7109 77.9773 51.1094C77.9773 49.0977 79.8816 47.6914 82.5672 47.6914C85.2918 47.6914 87.2254 49.0977 87.2352 51.1094C87.2254 52.7012 86.0145 53.9316 84.1492 54.3613V55.5234C85.5066 55.4453 86.8543 55.3281 88.1531 55.1523L88.3484 57.457C84.4715 58.1602 80.3211 58.1895 77.1766 58.1797L76.7859 55.6602ZM77.1375 47.1836V44.7617H81.0242V43.0039H84.1688V44.7617H88.0359V47.1836H77.1375ZM80.9656 51.1094C80.9656 51.8613 81.6395 52.1836 82.5672 52.1836C83.573 52.1836 84.2273 51.8613 84.2273 51.1094C84.2273 50.3867 83.573 50.0547 82.5672 50.0352C81.6395 50.0547 80.9656 50.3867 80.9656 51.1094ZM53.2332 70.6367V73.0586H48.4871V73.8984H55.1668V76.3398H38.6824V73.8984H45.323V73.0586H40.6551V67.4141H53.116V69.8945H43.7605V70.6367H53.2332ZM40.5184 84.8555V79.7773H50.1277V79.2109H40.5379V76.9453H53.2137V81.9062H43.5848V82.5117H53.6434V84.8555H40.5184ZM70.041 66.8672V84.9922H66.916V66.8672H70.041ZM55.6855 80.8516V73.1562H61.1738V70.793H55.6855V68.293H64.377V75.5977H58.9277V78.3027C61.5059 78.2734 63.625 78.1172 65.9199 77.7266L66.1738 80.2461C63.4395 80.7637 60.8027 80.8613 57.3848 80.8516H55.6855ZM86.1848 66.8672V84.9336H83.0012V66.8672H86.1848ZM70.8137 79.5625C75.3156 77.4238 77.1223 74.9434 77.5324 71.1641H71.8488V68.7227H80.716C80.7258 74.377 79.1242 78.8984 72.4152 82.0234L70.8137 79.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_826_14306",
    x: -4,
    y: 0,
    width: 135.04,
    height: 135.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_826_14306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_826_14306",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_826_14306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_826_14306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_826_14306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_826_14306",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinButton5);
export default __webpack_public_path__ + "static/media/spin-button5.c856515c0c9fcf6bf25e44a9c8d1958c.svg";
export { ForwardRef as ReactComponent };